/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import {
  selectCartesianFilters,
  // selectDynamics,
  // selectMechanics,
  setCartesianFilters
} from "../../../store/slices/cartesian";
import { syncCartesianFiltersDependencies } from "../../../utils/api/api";
// import SelectionRange from "../../../components/Inputs/SelectionRange/SelectionRange";
// import MultiRangeSlider from "./MultiRangeSlider";
import AxisSelectionFilterFiltersButton from "./AxisSelectionFilterFiltersButton";
import AxisSelectionFilterFiltersSection from "./AxisSelectionFilterFiltersSection";

const AxisSelectionFilter = ({ refetchAxesCombinations, resetAxesToCompare }) => {
  const [filtersOpened, setFiltersOpened] = useState(true);
  const cartesianFilters = useSelector(selectCartesianFilters);

  const [dependencies, setDependencies] = useState(null);

  const {
    refetch: syncDependencies,
    isLoading: isLoadingDependencies,
    isFetching: isFetchingDependencies
  } = useQuery(
    "Get axes dependencies",
    async () => {
      try {
        console.log("Sync dependencies");
        setDependencies(null);

        const payload = {
          device: "ALL",
          criteria: {
            locale: "en-WW",
            applicationData: {
              withCoverstrip: cartesianFilters?.applicationDataFilter?.withCoverstrip
            },
            axis: {
              driveType: cartesianFilters?.axisFilter?.driveType || null,
              profileDimension: cartesianFilters?.axisFilter?.profileDimension || null,
              axisType: cartesianFilters?.axisFilter?.axisType || null,
              functionAvailable: cartesianFilters?.axisFilter?.functionAvailable || null
            },
            mechanicalDrive: {
              functionAvailable: cartesianFilters?.mechanicalDriveFilter?.functionAvailable
            },
            guide: {
              guideType: cartesianFilters?.guideFilter?.guideType || null,
              functionAvailable: cartesianFilters?.guideFilter?.functionAvailable
            }
            //,
            // carriage: {
            //   maxVelocity: 0,
            //   maxAcceleration: 0
            // }
          }
        };

        // const result = await syncCartesianFiltersDependencies(payload);
        // console.log("dependencies result", result);

        // to figure out if "with cover strip" is switchable, we should send a request with inversed value
        // and check out if the count of axis combinations is greater than 0
        const payloadForCoverStrip = {
          ...payload,
          criteria: {
            ...payload.criteria,
            applicationData: {
              withCoverstrip: !cartesianFilters?.applicationDataFilter?.withCoverstrip
            }
          }
        };
        // const resultForCoverStrip = await syncCartesianFiltersDependencies(payloadForCoverStrip);

        // "antistatic belt"
        const payloadForAntistaticBelt = {
          ...payload,
          criteria: {
            ...payload.criteria,
            mechanicalDrive: {
              functionAvailable: payload.criteria.mechanicalDrive.functionAvailable.includes("anti-static toothed belt")
                ? [null, "standard"]
                : ["anti-static toothed belt"]
            }
          }
        };

        // const resultForAntistaticBelt = await syncCartesianFiltersDependencies(payloadForAntistaticBelt);

        // "increased corrosion protection"
        const payloadForIncreasedCorrosionProtection = {
          ...payload,
          criteria: {
            ...payload.criteria,
            guide: {
              functionAvailable: payload.criteria.guide.functionAvailable.includes("increased corrosion resistance")
                ? [null, "standard"]
                : ["increased corrosion resistance"]
            }
          }
        };

        // const resultForIncreasedCorrosionProtection = await syncCartesianFiltersDependencies(
        //   payloadForIncreasedCorrosionProtection
        // );

        const payloadForProductType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              axisType: null
            }
          }
        };

        // Mechanical drive elements (drive type)
        const payloadForDriveType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              driveType: null
            }
          }
        };
        // const resultForDriveType = await syncCartesianFiltersDependencies(payloadForDriveType);

        // Axis profile size (profile dimension)
        const payloadForProfileDimension = {
          ...payload,
          criteria: {
            ...payload.criteria,
            axis: {
              profileDimension: null
            }
          }
        };
        // const resultForProfileDimension = await syncCartesianFiltersDependencies(payloadForProfileDimension);

        // Guide type
        const payloadForGuideType = {
          ...payload,
          criteria: {
            ...payload.criteria,
            guide: {
              guideType: null
            }
          }
        };
        // const resultForGuideType = await syncCartesianFiltersDependencies(payloadForGuideType);

        // run all dependencies at once
        const [
          result,
          resultForCoverStrip,
          resultForAntistaticBelt,
          resultForIncreasedCorrosionProtection,
          resultForProductType,
          resultForDriveType,
          resultForProfileDimension,
          resultForGuideType
        ] = await Promise.all([
          syncCartesianFiltersDependencies(payload),
          syncCartesianFiltersDependencies(payloadForCoverStrip),
          syncCartesianFiltersDependencies(payloadForAntistaticBelt),
          syncCartesianFiltersDependencies(payloadForIncreasedCorrosionProtection),
          syncCartesianFiltersDependencies(payloadForProductType),
          syncCartesianFiltersDependencies(payloadForDriveType),
          syncCartesianFiltersDependencies(payloadForProfileDimension),
          syncCartesianFiltersDependencies(payloadForGuideType)
        ]);

        setDependencies({
          ...result,
          withCoverStripSwitchable: resultForCoverStrip?.applicationData?.countOfAxisCombinations > 0,
          withAntistaticBeltSwitchable: resultForAntistaticBelt?.applicationData?.countOfAxisCombinations > 0,
          withIncreasedCorrosionProtectionSwitchable:
            resultForIncreasedCorrosionProtection?.applicationData?.countOfAxisCombinations > 0,
          axisType: resultForProductType?.axis?.axisType,
          driveType: resultForDriveType?.axis?.driveType,
          profileDimension: resultForProfileDimension?.axis?.profileDimension,
          guideType: resultForGuideType?.guide?.guideType
        });
        console.log("dependencies", dependencies);
        return result;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    async function fetchData() {
      try {
        await syncDependencies();
        //await refetchAxesCombinations();
      } catch (error) {
        console.error("Error executing functions:", error);
      }
    }
    fetchData();
  }, [cartesianFilters]);

  // const dynamics = useSelector(selectDynamics);
  // const mechanics = useSelector(selectMechanics);
  // get maximum value found for Input_Peak_velocity (dynamics step)
  //const maxPeakVelocity = Math.max(...dynamics.steps?.map((step) => step.peak));
  // get maximum value found for Input_Peak_Acceleration (Dynamics step)
  //const maxPeakAcceleration = Math.max(...dynamics.steps?.map((step) => step.aacc));
  // get Input_Stroke_Length (Mechanics step)
  //const strokeLength = mechanics.strokeLength;
  // TODO Ballscrew related CRs (ballscrew axes only)

  return (
    <div className="mt-20 flex flex-col space-y-4 text-sm select-none">
      <div className="flex">
        <AxisSelectionFilterFiltersButton
          filtersOpened={filtersOpened}
          isLoadingOrFetchingGetAxesCombinations={isLoadingDependencies || isFetchingDependencies}
          onClick={() => {
            if (!(isLoadingDependencies || isFetchingDependencies)) setFiltersOpened(!filtersOpened);
          }}
          cartesianFilters={cartesianFilters}
        />
      </div>
      {filtersOpened && (
        <AxisSelectionFilterFiltersSection
          dependencies={dependencies}
          isLoadingDependencies={isLoadingDependencies}
          isFetchingDependencies={isFetchingDependencies}
          onClose={() => {
            //setFiltersOpened(false);
          }}
          refetchAxesCombinations={refetchAxesCombinations}
          resetAxesToCompare={resetAxesToCompare}
          setCartesianFilters={setCartesianFilters}
          cartesianFilters={cartesianFilters}
        />
      )}
    </div>
  );
};

export default AxisSelectionFilter;
